import {axios} from "@/api/config";
// 查询安全风险信息管理列表
export function listTbWorkPermitInfo(params) {
    return axios.get(`/tbWorkPermitInfo/list`, params, true);
}

// 查询安全风险信息管理详细
export function getTbWorkPermitInfo(id) {
    return axios.get(`/tbWorkPermitInfo/${id}`, id, true)
}

// 新增安全风险信息管理
export function addTbWorkPermitInfo(params) {
    return axios.post('/tbWorkPermitInfo/addTbWorkPermitInfo', params, false);
}

// 修改安全风险信息管理
export function updateTbWorkPermitInfo(params) {
    return axios.post('/tbWorkPermitInfo/editTbWorkPermitInfo', params, false);
}


// 删除安全风险信息管理
export function delTbWorkPermitInfo(id) {
    return axios.delete(`/tbWorkPermitInfo/${id}`, true)
}
